import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Vertical = _resolveComponent("Vertical")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_aside, {
      class: _normalizeClass(["layout-aside", $setup.setCollapseStyle])
    }, {
      default: _withCtx(() => [
        ($setup.setShowLogo)
          ? (_openBlock(), _createBlock(_component_Logo, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_scrollbar, {
          class: "flex-auto",
          ref: "layoutAsideScrollbarRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Vertical, { menuList: _ctx.menuList }, null, 8, ["menuList"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["class"])
  ], 512)), [
    [_vShow, !$setup.isTagsViewCurrenFull]
  ])
}